module.exports = __webpack_public_path__ + "img/t2-gray.ab866efe.png";